// removed by extract-text-webpack-plugin
module.exports = {"defaultSeparator":"QuotesStorage__defaultSeparator___2YX8D","root":"QuotesStorage__root___-LcOg","header":"QuotesStorage__header___sGWm_","headerText":"QuotesStorage__headerText___kK4M8","body":"QuotesStorage__body___1h4Nk","inputGroup":"QuotesStorage__inputGroup___3FLfd","autoQuoteDeletion":"QuotesStorage__autoQuoteDeletion___BSfvN","autoQuoteDeletionEnabler":"QuotesStorage__autoQuoteDeletionEnabler___1qwUe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuotesStorate/QuotesStorage.scss
// module id = 973
// module chunks = 0